import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInfoPaneHeaderStyle } from './styles/info-pane-header-style';

export const InfoPaneHeader = ({
  isReadonly,
  i18n,
  title,
  onDelete,
  disableEdit,
  onEdit,
  editLabel,
}) => {
  const classes = useDefaultStyles(getInfoPaneHeaderStyle);

  return (
    <div className={classes.detailHeader}>
      <div className={classes.panelTitle}>{title}</div>

      <button
        className={classnames(classes.deleteBox, classes.iconBox, 'delete-button')}
        onClick={onDelete}
        aria-label="click to delete"
        disabled={isReadonly}
      >
        <div
          className={classnames(classes.blueIcon, classes.deleteIcon, isReadonly && classes.disabledButton)}
        />
        <div className={classnames(classes.headerText, isReadonly && classes.disabledButton)}>{i18n.getString(_TL_('Delete'))}</div>
      </button>

      { !disableEdit &&
        <button
          className={classnames(classes.editBox, classes.iconBox)}
          onClick={onEdit}
          aria-label="click to edit"
        >
          <div
            className={classnames(classes.blueIcon, classes.editIcon)}
          />
          <div className={classes.headerText}>{editLabel}</div>
        </button>
      }
    </div>
  );
};

InfoPaneHeader.propTypes = {
  onDelete: PropTypes.func.isRequired,
  isReadonly: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,

  disableEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  editLabel: PropTypes.string,
};

InfoPaneHeader.defaultProps = {
  isReadonly: false,
  disableEdit: false,
  onEdit: _.noop,
  editLabel: '',
};
